import { useEffect, useState } from "react";

function useGlobalDebounceHandler(value: string) {
  const [debouncedQuery, setDebouncedQuery] = useState<string>(value);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedQuery(value);
    }, 300);

    return () => {
      clearTimeout(handler);
    };
  }, [value]);

  return { debouncedQuery };
}

export default useGlobalDebounceHandler;
